"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5578],{

/***/ 50594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 58826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Drawer_Drawer; }
});

// UNUSED EXPORTS: getAnchor, isHorizontal

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(15463);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 3 modules
var Modal = __webpack_require__(11971);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Drawer/drawerClasses.js


function getDrawerUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDrawer', slot);
}
const drawerClasses = (0,generateUtilityClasses/* default */.Z)('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);
/* harmony default export */ var Drawer_drawerClasses = ((/* unused pure expression or super */ null && (drawerClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Drawer/Drawer.js
'use client';



const _excluded = ["BackdropProps"],
  _excluded2 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];














const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};
const useUtilityClasses = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${(0,capitalize/* default */.Z)(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${(0,capitalize/* default */.Z)(anchor)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getDrawerUtilityClass, classes);
};
const DrawerRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.drawer
}));
const DrawerDockedRoot = (0,styled/* default */.ZP)('div', {
  shouldForwardProp: styled/* rootShouldForwardProp */.FO,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver
})({
  flex: '0 0 auto'
});
const DrawerPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${(0,capitalize/* default */.Z)(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0,capitalize/* default */.Z)(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: (theme.vars || theme).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}

/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */
const Drawer = /*#__PURE__*/react.forwardRef(function Drawer(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDrawer'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      anchor: anchorProp = 'left',
      BackdropProps,
      children,
      className,
      elevation = 16,
      hideBackdrop = false,
      ModalProps: {
        BackdropProps: BackdropPropsProp
      } = {},
      onClose,
      open = false,
      PaperProps = {},
      SlideProps,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Slide/* default */.Z,
      transitionDuration = defaultTransitionDuration,
      variant = 'temporary'
    } = props,
    ModalProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ModalProps, _excluded),
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.
  const mounted = react.useRef(false);
  react.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor(theme, anchorProp);
  const anchor = anchorProp;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);
  const classes = useUtilityClasses(ownerState);
  const drawer = /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerPaper, (0,esm_extends/* default */.Z)({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0,clsx/* default */.Z)(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));
  if (variant === 'permanent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }
  const slidingDrawer = /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));
  if (variant === 'persistent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  }

  // variant === temporary
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerRoot, (0,esm_extends/* default */.Z)({
    BackdropProps: (0,esm_extends/* default */.Z)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: (0,clsx/* default */.Z)(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Drawer_Drawer = (Drawer);

/***/ }),

/***/ 59334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1048);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32793);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63961);
/* harmony import */ var _mui_base_composeClasses__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15463);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59773);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71657);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26336);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    inset,
    primary,
    secondary,
    dense
  } = ownerState;
  const slots = {
    root: ['root', inset && 'inset', dense && 'dense', primary && secondary && 'multiline'],
    primary: ['primary'],
    secondary: ['secondary']
  };
  return (0,_mui_base_composeClasses__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__/* .getListItemTextUtilityClass */ .L, classes);
};
const ListItemTextRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('div', {
  name: 'MuiListItemText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary}`]: styles.primary
    }, {
      [`& .${_listItemTextClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].secondary */ .Z.secondary}`]: styles.secondary
    }, styles.root, ownerState.inset && styles.inset, ownerState.primary && ownerState.secondary && styles.multiline, ownerState.dense && styles.dense];
  }
})(({
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  flex: '1 1 auto',
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, ownerState.primary && ownerState.secondary && {
  marginTop: 6,
  marginBottom: 6
}, ownerState.inset && {
  paddingLeft: 56
}));
const ListItemText = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemText(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiListItemText'
  });
  const {
      children,
      className,
      disableTypography = false,
      inset = false,
      primary: primaryProp,
      primaryTypographyProps,
      secondary: secondaryProp,
      secondaryTypographyProps
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, _excluded);
  const {
    dense
  } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
  let primary = primaryProp != null ? primaryProp : children;
  let secondary = secondaryProp;
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, {
    disableTypography,
    inset,
    primary: !!primary,
    secondary: !!secondary,
    dense
  });
  const classes = useUtilityClasses(ownerState);
  if (primary != null && primary.type !== _Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z && !disableTypography) {
    primary = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
      display: "block"
    }, primaryTypographyProps, {
      children: primary
    }));
  }
  if (secondary != null && secondary.type !== _Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z && !disableTypography) {
    secondary = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
      variant: "body2",
      className: classes.secondary,
      color: "text.secondary",
      display: "block"
    }, secondaryTypographyProps, {
      children: secondary
    }));
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListItemTextRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [primary, secondary]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (ListItemText);

/***/ }),

/***/ 5578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ShowTimesDrawer": function() { return /* binding */ ShowTimesDrawer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98396);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(58826);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(54799);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(62482);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(16216);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(63931);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(36872);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(59334);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(44012);
/* harmony import */ var _logic_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42125);
/* harmony import */ var _logic_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10029);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(50594);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(23508);
/* harmony import */ var _lang_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61671);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43795);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(60374);
/* harmony import */ var _logic_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7663);
/* harmony import */ var _logic_services_cinemas__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47488);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85945);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _shared_image_box_future__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58718);
/* harmony import */ var _movie_details_showtimes_days_filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67938);
/* harmony import */ var _shared_movie_collapse_list__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5929);






















var LocationIconBlue = "/icons/shared/location-icon-blue.svg";
var BodyImg = "/images/show-times/body.svg";
var BodyImg4k = "/images/show-times/body4k.svg";
var ShowTimes = "/icons/footer/showTimes.svg";
var HeaderImg = "/images/show-times/header.svg";
var HeaderImg4k = "/images/show-times/header4k.svg";
var ShowTimesDrawer = function() {
    var ref;
    var cityId = (0,_logic_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useCity */ .hA)().cityId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    var isRtl = (0,_lang_utils__WEBPACK_IMPORTED_MODULE_4__/* .checkIsRtl */ .TM)(router.locale);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), showTimeDate = ref1[0], setShowTimeDate = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), drawerSelectedCinema = ref2[0], setDrawerSelectedCinema = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_logic_state__WEBPACK_IMPORTED_MODULE_2__/* .useShowTimesDrawer */ .j0)(function(s) {
        return [
            s.isShowTimesDrawerOpen,
            s.setShowTimesDrawer
        ];
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z), 2), isShowTimesDrawerOpen = ref3[0], setShowTimesDrawer = ref3[1];
    var isMobileScreen = (0,_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(theme.breakpoints.down("laptop"));
    var selectedCinemas = (0,_logic_state__WEBPACK_IMPORTED_MODULE_2__/* .useCinemas */ .wj)(function(s) {
        return s.selectedCinemas;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z);
    var matches = (0,_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("(min-height:1000px)");
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_17__/* .useQueryClient */ .NL)();
    var ref4 = (0,_logic_services_cinemas__WEBPACK_IMPORTED_MODULE_7__/* .useGetCinemas */ .L8)({
        params: {
            cityId: cityId
        }
    }, {
        enabled: !!cityId
    }), cinemaData = ref4.data;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!cinemaData) return;
        if (selectedCinemas.length === 0 || selectedCinemas[0] === 0) {
            var ref;
            setDrawerSelectedCinema((ref = cinemaData === null || cinemaData === void 0 ? void 0 : cinemaData.cinema[0]) === null || ref === void 0 ? void 0 : ref.id);
        } else {
            setDrawerSelectedCinema(selectedCinemas[0]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedCinemas,
        cinemaData
    ]);
    var ref5 = (0,_logic_services__WEBPACK_IMPORTED_MODULE_3__/* .useGetShowtimesByOneCinema */ .Vw)({
        params: {
            cityId: cityId,
            cinemaId: drawerSelectedCinema
        }
    }, {
        enabled: isShowTimesDrawerOpen && !!cityId && !!drawerSelectedCinema
    }), sessionDates = ref5.data, isFetchingShowTimes = ref5.isFetching;
    var params = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            cityId: cityId,
            cinemaId: drawerSelectedCinema,
            date: showTimeDate,
            page: 1,
            limit: 4
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        drawerSelectedCinema,
        showTimeDate
    ]);
    var ref6 = (0,_logic_services__WEBPACK_IMPORTED_MODULE_3__/* .useGetShowTimesMoviesByDate */ .Fd)({
        params: params
    }, {
        enabled: !!drawerSelectedCinema && !!showTimeDate && !!cityId
    }), data = ref6.data, fetchNextPage = ref6.fetchNextPage, hasNextPage = ref6.hasNextPage, isFetching = ref6.isFetching, isFetchingNextPage = ref6.isFetchingNextPage;
    var movies = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        return (data === null || data === void 0 ? void 0 : data.pages) ? data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(group) {
            return group.data;
        }) : [];
    }, [
        data
    ]);
    var handleChange = function(event) {
        var value = event.target.value;
        setDrawerSelectedCinema(value);
        setShowTimeDate(null);
    };
    var callOnFilmHasBeenStarted = function() {
        // invalidate available dates
        queryClient.invalidateQueries([
            {
                method: "get",
                url: "showtimes",
                params: {
                    cityId: cityId,
                    cinemaId: drawerSelectedCinema || selectedCinemas
                }
            }, 
        ]);
        // invalidate movies
        queryClient.invalidateQueries([
            "showtimes-drawer-movies",
            "infinite",
            params
        ]);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setShowTimesDrawer(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router
    ]);
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
        anchor: "right",
        open: isShowTimesDrawerOpen,
        onClose: function() {
            return setShowTimesDrawer(false);
        },
        PaperProps: {
            sx: {
                backgroundColor: "transparent",
                boxShadow: "none",
                overflow: "hidden",
                width: isMobileScreen ? "100vw" : "50vw"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                height: "100vh",
                background: {
                    mobile: theme.palette.common.white,
                    tablet: "url(".concat(BodyImg, ") no-repeat"),
                    extraLargeDesktop: "url(".concat(BodyImg4k, ") no-repeat")
                },
                backgroundSize: matches ? "cover !important" : "100%",
                transform: isRtl && "scaleX(-1)"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                sx: {
                    width: {
                        mobile: "100vw",
                        tablet: "100%"
                    },
                    maxWidth: {
                        mobile: "none"
                    },
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            flexDirection: isRtl ? "row-reverse" : "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            height: {
                                mobile: "56px",
                                tablet: "100px"
                            },
                            width: "100%",
                            background: {
                                mobile: theme.palette.primary.main,
                                tablet: "url(".concat(HeaderImg, ") no-repeat"),
                                extraLargeDesktop: "url(".concat(HeaderImg4k, ") no-repeat")
                            },
                            backgroundSize: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                onClick: function() {
                                    return setShowTimesDrawer(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    sx: {
                                        color: theme.palette.common.white,
                                        width: 24,
                                        height: 24,
                                        marginInlineStart: {
                                            mobile: !isRtl && "16px",
                                            tablet: !isRtl && "28px"
                                        },
                                        marginInlineEnd: {
                                            mobile: isRtl && "16px",
                                            tablet: isRtl && "28px"
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_box_future__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                img: ShowTimes,
                                title: intl.formatMessage({
                                    id: "images.title.show_time"
                                }),
                                objectFit: "contain",
                                sx: {
                                    width: "24px",
                                    height: "24px",
                                    marginInlineStart: {
                                        mobile: !isRtl ? "32px" : "14px",
                                        tablet: !isRtl ? "70px" : "14px"
                                    },
                                    marginInlineEnd: {
                                        mobile: "14px",
                                        tablet: !isRtl ? "14px" : "70px"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                component: "span",
                                sx: {
                                    color: theme.palette.common.white,
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(20),
                                    fontWeight: 400,
                                    transform: isRtl && "scaleX(-1)"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    id: "show_times"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        sx: (_obj = {
                            height: "100%",
                            pr: {
                                mobile: 0,
                                tablet: !isRtl ? (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40) : (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(160)
                            },
                            pl: {
                                mobile: 0,
                                tablet: !isRtl ? (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(160) : (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40)
                            },
                            width: "100%",
                            mr: isRtl ? "auto" : 0,
                            ml: !isRtl ? "auto" : 0
                        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(1200), {
                            pr: !isRtl ? (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40) : (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(100),
                            pl: !isRtl ? (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(100) : (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40),
                            width: "95%"
                        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(1100), {
                            pr: !isRtl ? (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40) : (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(50),
                            pl: !isRtl ? (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(50) : (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40),
                            width: "90%"
                        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(640), {
                            width: "100%",
                            px: "0 !important"
                        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, "marginTop", (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(44)), _obj),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    justifyContent: isRtl ? "flex-end" : "flex-start",
                                    paddingInline: {
                                        mobile: "16px",
                                        tablet: "none"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    labelId: "cinema-select-label",
                                    id: "cinema-select",
                                    value: drawerSelectedCinema,
                                    onChange: function(event) {
                                        return handleChange(event);
                                    },
                                    fullWidth: true,
                                    displayEmpty: true,
                                    sx: {
                                        backgroundColor: theme.palette.lightGrey.main,
                                        maxWidth: {
                                            tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(440)
                                        },
                                        border: "none",
                                        outline: "none",
                                        ".MuiOutlinedInput-notchedOutline": {
                                            border: "none"
                                        },
                                        transform: isRtl && "scaleX(-1)"
                                    },
                                    MenuProps: {
                                        BackdropProps: {
                                            sx: {
                                                backgroundColor: "transparent",
                                                backdropFilter: "none"
                                            }
                                        },
                                        PaperProps: {
                                            sx: {
                                                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0.893452px 17.869px rgba(0, 0, 0, 0.160949)",
                                                backdropFilter: "blur(10px)"
                                            }
                                        },
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        }
                                    },
                                    renderValue: function(drawerSelectedCinema) {
                                        var ref, ref1;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                            direction: "row",
                                            sx: {
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    sx: {
                                                        backgroundColor: theme.palette.common.white,
                                                        width: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(36),
                                                        height: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(36),
                                                        borderRadius: "9px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        marginInlineEnd: "16px"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_box_future__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        img: LocationIconBlue,
                                                        title: intl.formatMessage({
                                                            id: "images.title.location"
                                                        }),
                                                        objectFit: "contain",
                                                        sx: {
                                                            width: "16px",
                                                            height: "16px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                                    sx: {
                                                        fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(20),
                                                        fontWeight: "400",
                                                        lineHeight: "30px",
                                                        color: theme.palette.grey[80]
                                                    },
                                                    children: (ref1 = cinemaData === null || cinemaData === void 0 ? void 0 : (ref = cinemaData.cinema) === null || ref === void 0 ? void 0 : ref.find(function(cinema) {
                                                        return cinema.id === drawerSelectedCinema;
                                                    })) === null || ref1 === void 0 ? void 0 : ref1.name
                                                })
                                            ]
                                        });
                                    },
                                    IconComponent: function(props) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)({}, props), {
                                            sx: {
                                                top: "calc(50% - 0.7em) !important",
                                                right: "27px !important"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                                sx: {
                                                    color: theme.palette.typography.color.secondary
                                                }
                                            })
                                        }));
                                    },
                                    children: cinemaData === null || cinemaData === void 0 ? void 0 : cinemaData.cinema.map(function(cinema) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                            value: cinema.id,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                    checked: drawerSelectedCinema === cinema.id
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                                    primary: cinema.name
                                                })
                                            ]
                                        }, cinema.id);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                sx: {
                                    marginTop: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(34),
                                    width: {
                                        mobile: "100%",
                                        tablet: "auto"
                                    },
                                    maxWidth: {
                                        mobile: "none",
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(650)
                                    }
                                },
                                children: sessionDates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    sx: {
                                        marginTop: {
                                            mobile: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40)
                                        },
                                        paddingX: 2,
                                        transform: isRtl && "scaleX(-1)"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_movie_details_showtimes_days_filter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        sessionsDate: sessionDates === null || sessionDates === void 0 ? void 0 : sessionDates.avaliableDates,
                                        showTimeDate: showTimeDate,
                                        selectDate: setShowTimeDate,
                                        returnFirstEnabledDate: function(date) {
                                            return setShowTimeDate(date.date);
                                        }
                                    })
                                })
                            }),
                            !isFetching && !isFetchingShowTimes && !isFetchingNextPage && ((movies === null || movies === void 0 ? void 0 : movies.length) === 0 || (sessionDates === null || sessionDates === void 0 ? void 0 : (ref = sessionDates.avaliableDates) === null || ref === void 0 ? void 0 : ref.length) === 0) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                        sx: {
                                            marginTop: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(80),
                                            marginBottom: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(24),
                                            display: "flex",
                                            justifyContent: "center",
                                            transform: isRtl && "scaleX(-1)"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_box_future__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            img: "/icons/movie-details/no-showtimes-available.svg",
                                            title: intl.formatMessage({
                                                id: "alt.no_show_time_available"
                                            }),
                                            objectFit: "contain",
                                            sx: {
                                                width: "300px",
                                                height: "202px"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        sx: {
                                            color: theme.palette.grey[50],
                                            fontWeight: 400,
                                            fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(20),
                                            lineHeight: "30px",
                                            textAlign: "center",
                                            transform: isRtl && "scaleX(-1)"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            id: "movies.there.is.no.showtimes"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                id: "scrollableDiv",
                                sx: {
                                    direction: isRtl ? "rtl" : "ltr",
                                    maxHeight: {
                                        mobile: "calc(100vh - 260px)",
                                        tablet: "calc(100vh - 360px)"
                                    },
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    width: {
                                        mobile: "100%",
                                        tablet: "100%"
                                    },
                                    marginTop: {
                                        mobile: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(40),
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(54)
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    sx: {
                                        transform: isRtl && "scaleX(-1)",
                                        direction: "ltr",
                                        marginBottom: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(60)
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_movie_collapse_list__WEBPACK_IMPORTED_MODULE_11__/* .MovieCollapseList */ .V, {
                                        movies: movies,
                                        hasMore: hasNextPage,
                                        fetchMovies: fetchNextPage,
                                        isFetching: isFetching || isFetchingShowTimes,
                                        isFetchingNextPage: isFetchingNextPage,
                                        showExperiencesBy: "film",
                                        infiniteScrollProps: {
                                            scrollThreshold: "200px",
                                            style: {
                                                overflow: "unset"
                                            },
                                            scrollableTarget: "scrollableDiv"
                                        },
                                        callOnFilmHasBeenStarted: callOnFilmHasBeenStarted,
                                        showTimeDate: showTimeDate
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ShowTimesDrawer);


/***/ }),

/***/ 47488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gr": function() { return /* reexport */ useGetCinemaDetails; },
  "ve": function() { return /* reexport */ useGetCinemaList; },
  "L8": function() { return /* reexport */ useGetCinemas; }
});

// UNUSED EXPORTS: getCinemaList, useGetCinema

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
// EXTERNAL MODULE: ./src/constants/cashing.ts
var cashing = __webpack_require__(29236);
;// CONCATENATED MODULE: ./src/logic/services/cinemas/services.ts



var url = "cinemas";
var getCinemaList = function(params) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return axiosInstance.get("".concat(url), _object_spread({
        params: params
    }, config)).then(function(res) {
        return res === null || res === void 0 ? void 0 : res.data;
    });
};
var useGetCinemaList = (0,libs/* createQuery */.rP)({
    url: "".concat(url),
    method: "get"
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinemaDetails = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});
var useGetCinemas = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url)
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinema = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});

;// CONCATENATED MODULE: ./src/logic/services/cinemas/index.ts




/***/ })

}]);